module.exports = __webpack_public_path__ + "resources/img/logo_partner_commerce_1_m.39b2d2cae0184c64d1914fdcfa49e866.png";